
import Vue from "vue";
import { Script, ExtraArgTypes, StandardArgTypes, StandardArg, ExtraArg } from "@/models/script";
import { ISelectItem } from "winfakt-vue-components";
import AppTranslationEdit from "@/components/TranslationEdit.vue";
import AppStructureEdit from "@/components/dossier/DossierScriptEditStructureArgument.vue";
import { ScriptService } from "@/services";

export default Vue.extend({
	data(){
		return {
			scriptTypes: [] as ISelectItem<string>[]
		};
	},
	props: {
		script: {
			type: Object as ()=>Script,
			required: true
		},
		dossierId: {
			type: Number,
			required: true
		}
	},
	computed: {
		// eslint-disable-next-line max-lines-per-function
		extraArgTypeItems():ISelectItem<ExtraArgTypes>[]{
			return Object.values(ExtraArgTypes).map((o)=>{
				return {
					text: o as string,
					value: o as ExtraArgTypes
				};
			});
		},
		standardArgTypeItems():ISelectItem<StandardArgTypes>[]{
			return [
				{
					text: "String",
					value: "string"
				},
				{
					text: "Table Structure",
					value: "table-structure"
				}
			];
		},
		standardArgTooltip():string{
			// eslint-disable-next-line max-len
			return `Standard arguments zijn argumenten dat verzonden worden naar de scripting server zonder dat de gebruiker ze manueel nog moet invullen. Dit zijn vooral constante waardes zoals de tabel structuur.`;
		},
		extraArgTooltip():string{
			return `Extra argumenten zijn argumenten die de gebruiker mee geeft tijdens het genereren van de script. Dit kan bijvoorbeeld de datum range zijn van een rapport.`;
		}
	},
	methods: {
		removeStandardArg(i:number){
			this.script.StandardArgs.splice(i, 1);
		},
		addStandardArg(){
			this.script.StandardArgs.push(new StandardArg());
		},
		addExtraArg(){
			this.script.ExtraArgs.push(new ExtraArg());
		},
		removeExtraArg(i:number){
			this.script.ExtraArgs.splice(i, 1);
		},
		close(){
			this.$emit("close");
		}
	},
	async created(){
		this.scriptTypes = await ScriptService.getScriptTypes(this.dossierId);
	},
	components: {
		AppTranslationEdit,
		AppStructureEdit
	}
});
